import { StoreValue } from "@apollo/client";

import { OptionProps } from "./types";

export const currencyFormatter = (value: number) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);

export const inputCurrencyParser = (value?: string) => {
  if (value) {
    return value.replace(/\$\s?|(,*)/g, "");
  }

  return "";
};

export const inputCurrencyFormatter = (value?: string) =>
  `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const filterOptionInsensitive = (input: string, option?: OptionProps) =>
  option?.label?.toLowerCase().includes(input.toLowerCase()) || false;

export const swapValue = (
  values: OptionProps[],
  valueToSwap: StoreValue,
  defaultValue?: string
) => ({
  value:
    values.find(({ value }) => value === valueToSwap)?.label || defaultValue,
});
